export const gardenSurfaces = [
  "app",
  "clip",
  "messages",
  "messagesCompact",
] as const;
export type GardenSurface = (typeof gardenSurfaces)[number];

/** Presentation hints are never authorization. The API still checks each operation. */
export function gardenSurface(search = location.search): GardenSurface | null {
  const value = new URLSearchParams(search).get("gardenSurface");
  return gardenSurfaces.includes(value as GardenSurface)
    ? (value as GardenSurface)
    : null;
}

export function mobileURL(path: string, surface = gardenSurface() ?? "app") {
  const url = new URL(path, location.origin);
  if (url.origin !== location.origin)
    throw new Error("Use a Garden link from this server.");
  url.searchParams.set("gardenSurface", surface);
  return url.pathname + url.search + url.hash;
}

export function hostContext(
  frame: HTMLIFrameElement | null,
  editable: boolean,
) {
  return {
    runtimeVersion: 1,
    surface: gardenSurface() ?? "browser",
    viewport: {
      width: Math.round(frame?.clientWidth ?? innerWidth),
      height: Math.round(frame?.clientHeight ?? innerHeight),
    },
    capabilities: {
      state: editable ? "write" : "read",
      backend: true,
      sockets: true,
      expand: true,
      followUp: gardenSurface() ? "host-ui" : "unavailable",
    },
  };
}
